// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"notFoundPage_wrapper__2WulX","titlePage":"notFoundPage_titlePage__Vk01V"};